import type { EmailBlock, TemplateBlockKind, TemplateEditor } from './types';

/** Domínio de teste que o MailerSend entrega na conta sandbox. Dado fictício. */
export const SANDBOX_DOMAIN = 'trial-tea.mlsender.net';

export const EDITOR_META: Record<TemplateEditor, { label: string; detail: string }> = {
  'drag-drop': {
    label: 'Arrastar e soltar',
    detail: 'Modelo antigo do sandbox, em blocos.',
  },
  html: {
    label: 'HTML',
    detail: 'HTML próprio e a versão em texto.',
  },
  'rich-text': {
    label: 'Texto rico',
    detail: 'Mensagem corrida, com personalização.',
  },
  beefree: {
    label: 'Beefree',
    detail: 'Conteúdo editado no Beefree SDK.',
  },
};

export const BLOCK_CATALOG: Array<{ kind: TemplateBlockKind; label: string; placeholder: string }> = [
  { kind: 'header', label: 'Cabeçalho', placeholder: 'Nome da loja' },
  { kind: 'hero', label: 'Destaque', placeholder: 'Título principal' },
  { kind: 'text', label: 'Texto', placeholder: 'Escreva a mensagem' },
  { kind: 'image', label: 'Imagem', placeholder: 'Descrição da imagem' },
  { kind: 'button', label: 'Botão', placeholder: 'Texto do botão' },
  { kind: 'product', label: 'Produto', placeholder: 'Nome do produto' },
  { kind: 'social', label: 'Redes', placeholder: 'Instagram, site' },
  { kind: 'divider', label: 'Divisor', placeholder: '' },
];

export function blockKindMeta(kind: TemplateBlockKind) {
  return BLOCK_CATALOG.find((item) => item.kind === kind) ?? BLOCK_CATALOG[2];
}

export function createBlock(kind: TemplateBlockKind, text = ''): EmailBlock {
  const meta = blockKindMeta(kind);
  return {
    id: `blk-${kind}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
    kind,
    label: meta.label,
    text,
  };
}

export function blocksToPlainText(blocks: EmailBlock[]): string {
  return blocks
    .map((block) => block.text.trim())
    .filter(Boolean)
    .join('\n\n');
}

export function blocksToHtml(blocks: EmailBlock[]): string {
  return blocks
    .map((block) => {
      const text = escapeHtml(block.text.trim());
      if (!text && block.kind !== 'divider') return '';
      if (block.kind === 'hero' || block.kind === 'header') return `<h1>${text}</h1>`;
      if (block.kind === 'button') return `<p><a href="{{link}}">${text}</a></p>`;
      if (block.kind === 'image') return `<p>[imagem: ${text}]</p>`;
      if (block.kind === 'divider') return '<hr />';
      return `<p>${text}</p>`;
    })
    .filter(Boolean)
    .join('\n');
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

/** Texto simples a partir do HTML, para o campo `text` da API. */
export function htmlToPlainText(html: string): string {
  return html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
